/////////////////////////////////////////////////////////
// Dhobara listing configuration                       //
// All fields defined in code (200+ designer options)  //
/////////////////////////////////////////////////////////

// ── Designers ─────────────────────────────────────────────────────────────────
// Sourced from Lovable codebase designers.ts, sorted A–Z
import SHIPPING_TIERS from './shipping-tiers.json';

export const DESIGNER_OPTIONS = [
  { option: 'aanchal-sayal', label: 'Aanchal Sayal' },
  { option: 'abhinav-mishra', label: 'Abhinav Mishra' },
  { option: 'abhishek-sharma', label: 'Abhishek Sharma' },
  { option: 'abraham-thakore', label: 'Abraham & Thakore' },
  { option: 'abu-jani-sandeep-khosla', label: 'Abu Jani Sandeep Khosla' },
  { option: 'adarsh-gill', label: 'Adarsh Gill' },
  { option: 'advait', label: 'Advait' },
  { option: 'ahilian', label: 'Ahilian' },
  { option: 'aisha-rao', label: 'Aisha Rao' },
  { option: 'ajiesh-oberoi', label: 'Ajiesh Oberoi' },
  { option: 'akanksha-gajaria', label: 'Akanksha Gajaria' },
  { option: 'ak-ok', label: 'AK-OK' },
  { option: 'ali-xeeshan', label: 'Ali Xeeshan' },
  { option: 'amber-by-ecru', label: 'Amber By Ecru / Ankur Batra' },
  { option: 'amir-adnan', label: 'Amir Adnan' },
  { option: 'amit-aggarwal', label: 'Amit Aggarwal' },
  { option: 'amit-gt', label: 'Amit GT' },
  { option: 'ammara-khan', label: 'Ammara Khan' },
  { option: 'ampm', label: 'AMPM' },
  { option: 'amrita-thakur', label: 'Amrita Thakur' },
  { option: 'anamika-khanna', label: 'Anamika Khanna' },
  { option: 'anand-kabra', label: 'Anand Kabra' },
  { option: 'anavila', label: 'Anavila' },
  { option: 'aneesh-agarwaal', label: 'Aneesh Agarwaal' },
  { option: 'angad-singh', label: 'Angad Singh' },
  { option: 'anita-dongre', label: 'Anita Dongre' },
  { option: 'anita-dongre-grassroot', label: 'Anita Dongre Grassroot' },
  { option: 'anjul-bhandari', label: 'Anjul Bhandari' },
  { option: 'anju-modi', label: 'Anju Modi' },
  { option: 'antar-agni', label: 'Antar Agni' },
  { option: 'anuradha-vakil', label: 'Anuradha Vakil' },
  { option: 'anushree-reddy', label: 'Anushree Reddy' },
  { option: 'archana-jaju', label: 'Archana Jaju' },
  { option: 'archana-kochhar', label: 'Archana Kochhar' },
  { option: 'archana-shah', label: 'Archana Shah' },
  { option: 'armaan-by-sunaina-puri', label: 'Armaan By Sunaina Puri' },
  { option: 'aroka', label: 'Aroka' },
  { option: 'arpita-mehta', label: 'Arpita Mehta' },
  { option: 'arya-by-sva', label: 'ARYA By SVA' },
  { option: 'asal-by-abu-sandeep', label: 'ASAL By Abu Sandeep' },
  { option: 'aseem-kapoor', label: 'Aseem Kapoor' },
  { option: 'asim-jofa', label: 'Asim Jofa' },
  { option: 'astha-jagwani', label: 'Astha Jagwani' },
  { option: 'astha-narang', label: 'Astha Narang' },
  { option: 'avvantikaa-s-parwani', label: 'Avvantikaa S Parwani' },
  { option: 'ayesha-usman', label: 'Ayesha & Usman' },
  { option: 'baise-gaba', label: 'Baise Gaba' },
  { option: 'balance-by-rohit-bal', label: 'Balance By Rohit Bal' },
  { option: 'begum-pret', label: 'Begum Pret' },
  { option: 'bhairavi-jaikishan', label: 'Bhairavi Jaikishan' },
  { option: 'bhumika-sharma', label: 'Bhumika Sharma' },
  { option: 'bindani', label: 'Bindani' },
  { option: 'bodice', label: 'Bodice' },
  { option: 'bunto-kazmi', label: 'Bunto Kazmi' },
  { option: 'cedar-pine', label: 'Cedar Pine' },
  { option: 'chaitenya-mittal', label: 'Chaitenya Mittal' },
  { option: 'chamee-and-palak', label: 'Chamee And Palak' },
  { option: 'chandrima', label: 'Chandrima' },
  { option: 'chhavvi-aggarwal', label: 'Chhavvi Aggarwal' },
  { option: 'chola', label: 'Chola' },
  { option: 'citrine-designs-studio', label: 'Citrine Designs Studio' },
  { option: 'collaboration', label: 'Collaboration' },
  { option: 'color-coded-crime', label: 'Color Coded Crime' },
  { option: 'contessa-dubai', label: 'Contessa Dubai' },
  { option: 'cord', label: 'Cord' },
  { option: 'cord-studio', label: 'Cord Studio' },
  { option: 'couture-by-niharika', label: 'Couture By Niharika' },
  { option: 'cuin', label: 'Cuin' },
  { option: 'dash-dot', label: 'Dash & Dot' },
  { option: 'debyani', label: 'Debyani' },
  { option: 'deepak-perwani', label: 'Deepak Perwani' },
  { option: 'deepika-arora', label: 'Deepika Arora' },
  { option: 'devnaagri', label: 'Devnaagri' },
  { option: 'dev-r-nil', label: 'Dev R Nil' },
  { option: 'devyani-mehrotra', label: 'Devyani Mehrotra' },
  { option: 'dhruv-kapoor', label: 'Dhruv Kapoor' },
  { option: 'dhruv-vaish', label: 'Dhruv Vaish' },
  { option: 'disha-patil', label: 'Disha Patil' },
  { option: 'divani-india', label: 'Divani India' },
  { option: 'divyam-mehta', label: 'Divyam Mehta' },
  { option: 'divya-sheth', label: 'Divya Sheth' },
  { option: 'diyarajvvir', label: 'DiyaRajvvir' },
  { option: 'dolly-j', label: 'Dolly J' },
  { option: 'dozakh', label: 'Dozakh' },
  { option: 'drishti-zahabia', label: 'Drishti Zahabia' },
  { option: 'dyelogue-by-rachita-parekh', label: 'Dyelogue By Rachita Parekh' },
  { option: 'ecru-by-ankur-batra', label: 'Ecru By Ankur Batra' },
  { option: 'eena', label: 'Eena' },
  { option: 'eka', label: 'Eka' },
  { option: 'ekaya', label: 'Ekaya' },
  { option: 'ekru', label: 'Ekru' },
  { option: 'ekru-by-ekta-ruchira', label: 'Ekru By Ekta Ruchira' },
  { option: 'ek-soot', label: 'Ek Soot' },
  { option: 'elan', label: 'Élan' },
  { option: 'ensemble', label: 'Ensemble' },
  { option: 'esha-koul', label: 'Esha Koul' },
  { option: 'esha-sethi-thirani', label: 'Esha Sethi Thirani' },
  { option: 'esse', label: 'Esse' },
  { option: 'expressionist-by-jaspreet', label: 'Expressionist By Jaspreet' },
  { option: 'faabiiana', label: 'Faabiiana' },
  { option: 'fahad-hussayn', label: 'Fahad Hussayn' },
  { option: 'faiza-saqlain', label: 'Faiza Saqlain' },
  { option: 'falguni-and-shane-peacock', label: 'Falguni And Shane Peacock' },
  { option: 'falguni-shane-peacock', label: 'Falguni Shane Peacock' },
  { option: 'farah-talib-aziz', label: 'Farah Talib Aziz' },
  { option: 'faraz-manan', label: 'Faraz Manan' },
  { option: 'farha-khan', label: 'Farha Khan' },
  { option: 'farida-hasan', label: 'Farida Hasan' },
  { option: 'fern', label: 'Fern' },
  { option: 'gaurang', label: 'Gaurang' },
  { option: 'gaurang-shah', label: 'Gaurang Shah' },
  { option: 'gaurav-gupta', label: 'Gaurav Gupta' },
  { option: 'gauri-and-nainika', label: 'Gauri And Nainika' },
  { option: 'gazal-gupta', label: 'Gazal Gupta' },
  { option: 'gazal-mishra', label: 'Gazal Mishra' },
  { option: 'geisha-designs', label: 'Geisha Designs' },
  { option: 'good-earth', label: 'Good Earth' },
  { option: 'gopi-vaid', label: 'Gopi Vaid' },
  { option: 'graine', label: 'Graine' },
  { option: 'gulabo-by-abu-sandeep', label: 'Gulabo By Abu Sandeep' },
  { option: 'hsy', label: 'Hassan Sheheryar Yasin (HSY)' },
  { option: 'heena-kochhar', label: 'Heena Kochhar' },
  { option: 'hemang-agrawal', label: 'Hemang Agrawal' },
  { option: 'hemant-nandita', label: 'Hemant Nandita' },
  { option: 'himani-anjali-shah', label: 'Himani & Anjali Shah' },
  { option: 'house-of-kotwara', label: 'House Of Kotwara' },
  { option: 'house-of-pink', label: 'House Of Pink' },
  { option: 'house-of-three', label: 'House Of Three' },
  { option: 'hussain-rehar', label: 'Hussain Rehar' },
  { option: 'ilk', label: 'ILK' },
  { option: 'inej', label: 'Inej' },
  { option: 'isa-by-dolly-wahal', label: 'ISA By Dolly Wahal' },
  { option: 'itrh', label: 'Itrh' },
  { option: 'iznik', label: 'Iznik' },
  { option: 'jade', label: 'JADE By Monica And Karishma' },
  { option: 'jashan', label: 'Jashan' },
  { option: 'jatin-malik', label: 'Jatin Malik' },
  { option: 'jayanti-reddy', label: 'Jayanti Reddy' },
  { option: 'jaya-rathore', label: 'Jaya Rathore' },
  { option: 'jayati-goenka', label: 'Jayati Goenka' },
  { option: 'jj-valaya', label: 'JJ Valaya' },
  { option: 'joy-mitra', label: 'Joy Mitra' },
  { option: 'jugnu-lahore', label: 'Jugnu Lahore' },
  { option: 'kalista', label: 'Kalista' },
  { option: 'kamaali-pret', label: 'Kamaali Pret' },
  { option: 'kanelle', label: 'Kanelle' },
  { option: 'kanika-goyal-label', label: 'Kanika Goyal Label' },
  { option: 'kanika-sharma', label: 'Kanika Sharma' },
  { option: 'ka-sha', label: 'Ka-Sha' },
  { option: 'kasturi-kundal', label: 'Kasturi Kundal' },
  { option: 'kavita-bhartia', label: 'Kavita Bhartia' },
  { option: 'khara-kapas', label: 'Khara Kapas' },
  { option: 'kiran-uttam-ghosh', label: 'Kiran Uttam Ghosh' },
  { option: 'koai', label: 'KoAi' },
  { option: 'koashee-by-shubhitaa', label: 'Koasheé By Shubhitaa' },
  { option: 'komal-shah', label: 'Komal Shah' },
  { option: 'komal-sood', label: 'Komal Sood' },
  { option: 'kora', label: 'Kora' },
  { option: 'koravi', label: 'Koravi' },
  { option: 'korvai', label: 'Korvai' },
  { option: 'kresha-bajaj', label: 'Kresha Bajaj' },
  { option: 'kunal-rawal', label: 'Kunal Rawal' },
  { option: 'kyra-by-mandira-wirk', label: 'Kyra By Mandira Wirk' },
  { option: 'label-ritu-kumar', label: 'Label Ritu Kumar' },
  { option: 'lajjoo-c', label: 'Lajjoo C' },
  { option: 'liz-paul', label: 'Liz Paul' },
  { option: 'lovebirds', label: 'LoveBirds' },
  { option: 'love-shafali', label: 'Love Shafali' },
  { option: 'maayera-jaipur', label: 'Maayera Jaipur' },
  { option: 'madsam-tinzin', label: 'Madsam Tinzin' },
  { option: 'madzin', label: 'MadZin' },
  { option: 'maheen-taseer', label: 'Maheen Taseer' },
  { option: 'mahgul', label: 'Mahgul' },
  { option: 'mahima-mahajan', label: 'Mahima Mahajan' },
  { option: 'maison-blu', label: 'Maison Blu' },
  { option: 'maison-shefali', label: 'Maison Shefali' },
  { option: 'mala-and-kinnary', label: 'Mala And Kinnary' },
  { option: 'manav-gangwani', label: 'Manav Gangwani' },
  { option: 'mandira-wirk', label: 'Mandira Wirk' },
  { option: 'manish-arora', label: 'Manish Arora' },
  { option: 'manish-gupta', label: 'Manish Gupta' },
  { option: 'manish-malhotra', label: 'Manish Malhotra' },
  { option: 'mansi-nagdev', label: 'Mansi Nagdev' },
  { option: 'maria-b', label: 'Maria B.' },
  { option: 'masaba', label: 'Masaba' },
  { option: 'mati', label: 'Mati' },
  { option: 'matsya', label: 'Matsya' },
  { option: 'mayank-modi', label: 'Mayank Modi' },
  { option: 'mayyur-girotra', label: 'Mayyur Girotra' },
  { option: 'megha-bansal', label: 'Megha Bansal' },
  { option: 'megha-jigar', label: 'Megha Jigar' },
  { option: 'meghna-panchmatia', label: 'Meghna Panchmatia' },
  { option: 'mehul-gupta', label: 'Mehul Gupta' },
  { option: 'mimamsaa-by-ankita-singh', label: 'MimamsAa By Ankita Singh' },
  { option: 'mina-hassan', label: 'Mina Hassan' },
  { option: 'minaxi-dadoo', label: 'Minaxi Dadoo' },
  { option: 'mireya-sanya', label: 'Mireya Sanya' },
  { option: 'misha-lakhani', label: 'Misha Lakhani' },
  { option: 'mishru', label: 'Mishru' },
  { option: 'misri', label: 'Misri' },
  { option: 'mohsin-naveed-ranjha', label: 'Mohsin Naveed Ranjha' },
  { option: 'monika-nidhii', label: 'Monika Nidhii' },
  { option: 'monisha-jaising', label: 'Monisha Jaising' },
  { option: 'mrunalini-rao', label: 'Mrunalini Rao' },
  { option: 'mulmul', label: 'Mulmul' },
  { option: 'munib-nawaz', label: 'Munib Nawaz' },
  { option: 'musal', label: 'Musal' },
  { option: 'muse', label: 'Muse' },
  { option: 'mynah-s-reynu-taandon', label: "Mynah's Reynu Taandon" },
  { option: 'myoho', label: 'Myoho' },
  { option: 'nachiket-barve', label: 'Nachiket Barve' },
  { option: 'nadia-farooqi', label: 'Nadia Farooqi' },
  { option: 'nafisa-rachel-william', label: 'Nafisa Rachel William' },
  { option: 'nakul-sen', label: 'Nakul Sen' },
  { option: 'namrata-joshipura', label: 'Namrata Joshipura' },
  { option: 'natasha-dalal', label: 'Natasha Dalal' },
  { option: 'neeru-kumar', label: 'Neeru Kumar' },
  { option: 'neeta-lulla', label: 'Neeta Lulla' },
  { option: 'neha-tarun', label: 'Neha Tarun' },
  { option: 'nickie-nina', label: 'Nickie Nina' },
  { option: 'nida-azwer', label: 'Nida Azwer' },
  { option: 'nidhi-tholia', label: 'Nidhi Tholia' },
  { option: 'nikasha', label: 'Nikasha' },
  { option: 'nikhil-thampi', label: 'Nikhil Thampi' },
  { option: 'nikhita-tandon', label: 'Nikhita Tandon' },
  { option: 'nikita-mhaisalkar', label: 'Nikita Mhaisalkar' },
  { option: 'nitya-bajaj', label: 'Nitya Bajaj' },
  { option: 'nomi-ansari', label: 'Nomi Ansari' },
  { option: 'not-so-serious-by-pallavi-mohan', label: 'Not So Serious By Pallavi Mohan' },
  { option: 'nupur-kanoi', label: 'Nupur Kanoi' },
  { option: 'ohaila-khan', label: 'Ohaila Khan' },
  { option: 'open-button', label: 'Open Button' },
  { option: 'osaa-by-adarsh', label: 'Osaa By Adarsh' },
  { option: 'osami', label: 'Osami' },
  { option: 'paari', label: 'Paari' },
  { option: 'pallavi-jaikishan', label: 'Pallavi Jaikishan' },
  { option: 'pallavi-jaipur', label: 'Pallavi Jaipur' },
  { option: 'palve', label: 'Palve' },
  { option: 'pankaj-nidhi', label: 'Pankaj & Nidhi' },
  { option: 'pankaj-nidhi-couture', label: 'Pankaj Nidhi Couture' },
  { option: 'papa-dont-preach', label: "Papa Don't Preach" },
  { option: 'parul-and-preyanka', label: 'Parul And Preyanka' },
  { option: 'patine', label: 'Patine' },
  { option: 'paulmi-harsh', label: 'Paulmi & Harsh' },
  { option: 'payal-keyal', label: 'Payal Keyal' },
  { option: 'payal-khandwala', label: 'Payal Khandwala' },
  { option: 'payal-pratap', label: 'Payal Pratap' },
  { option: 'payal-singhal', label: 'Payal Singhal' },
  { option: 'pero', label: 'Péro' },
  { option: 'petticoat-lane-by-divya', label: 'Petticoat Lane By Divya' },
  { option: 'picchika-by-urvashi-sethi', label: 'Picchika By Urvashi Sethi' },
  { option: 'pink-city-by-sarika', label: 'Pink City By Sarika' },
  { option: 'pink-peacock-couture', label: 'Pink Peacock Couture' },
  { option: 'pooja-peshoria', label: 'Pooja Peshoria' },
  { option: 'prama-by-pratima-pandey', label: 'Prama By Pratima Pandey' },
  { option: 'pratap', label: 'Pratap' },
  { option: 'prathyusha-garimella', label: 'Prathyusha Garimella' },
  { option: 'pratibha-sultania', label: 'Pratibha Sultania' },
  { option: 'preeti-s-kapoor', label: 'Preeti S Kapoor' },
  { option: 'pria-kataaria-puri', label: 'Pria Kataaria Puri' },
  { option: 'priti-prashant', label: 'Priti Prashant' },
  { option: 'priyal-prakash', label: 'Priyal Prakash' },
  { option: 'ps-by-payal-singhal', label: 'PS By Payal Singhal' },
  { option: 'puja-nayyar', label: 'Puja Nayyar' },
  { option: 'punit-arora', label: 'Punit Arora' },
  { option: 'punit-balana', label: 'Punit Balana' },
  { option: 'qbik', label: 'Qbik' },
  { option: 'rabani-rakha', label: 'Rabani Rakha' },
  { option: 'radhika-naik', label: 'Radhika Naik' },
  { option: 'raghavendra-rathore', label: 'Raghavendra Rathore' },
  { option: 'rahul-mishra', label: 'Rahul Mishra' },
  { option: 'raja-salahuddin', label: 'Raja Salahuddin' },
  { option: 'rajdeep-ranawat', label: 'Rajdeep Ranawat' },
  { option: 'rajesh-pratap-singh', label: 'Rajesh Pratap Singh' },
  { option: 'rajiramniq', label: 'Rajiramniq' },
  { option: 'ranna-gill', label: 'Ranna Gill' },
  { option: 'rashi-jain', label: 'Rashi Jain' },
  { option: 'rastah', label: 'Rastah' },
  { option: 'raw-mango', label: 'Raw Mango' },
  { option: 'reeti-arneja', label: 'Reeti Arneja' },
  { option: 'rema-sherbano', label: 'Rema & Sherbano' },
  { option: 'republic-by-omar-farooq', label: 'Republic By Omar Farooq' },
  { option: 'riddhi-majithia', label: 'Riddhi Majithia' },
  { option: 'ridhima-bhasin', label: 'Ridhima Bhasin' },
  { option: 'ridhi-mehra', label: 'Ridhi Mehra' },
  { option: 'rimple-harpreet-narula', label: 'Rimple And Harpreet Narula' },
  { option: 'rimzim-dadu', label: 'Rimzim Dadu' },
  { option: 'rina-dhaka', label: 'Rina Dhaka' },
  { option: 'rishi-soujit', label: 'Rishi & Soujit' },
  { option: 'ritika-mirchandani', label: 'Ritika Mirchandani' },
  { option: 'ritu-kumar', label: 'Ritu Kumar' },
  { option: 'ritu-singh', label: 'Ritu Singh' },
  { option: 'rohit-bal', label: 'Rohit Bal' },
  { option: 'rohit-gandhi-rahul-khanna', label: 'Rohit Gandhi + Rahul Khanna' },
  { option: 'rose-room-by-isha-namrita-rajpal', label: 'Rose Room By Isha & Namrita Rajpal' },
  { option: 'rozina-munib', label: 'Rozina Munib' },
  { option: 'runaway-bicycle', label: 'Runaway Bicycle' },
  { option: 'saaksha-kinni', label: 'Saaksha Kinni' },
  { option: 'sabyasachi', label: 'Sabyasachi' },
  { option: 'sadaf-fawad-khan', label: 'Sadaf Fawad Khan' },
  { option: 'sahil-kocchar', label: 'Sahil Kocchar' },
  { option: 'sailesh-singhania', label: 'Sailesh Singhania' },
  { option: 'saim', label: 'Saim' },
  { option: 'saira-rizwan', label: 'Saira Rizwan' },
  { option: 'saira-shakira', label: 'Saira Shakira' },
  { option: 'saksham-neharicka', label: 'Saksham Neharicka' },
  { option: 'samant-chauhan', label: 'Samant Chauhan' },
  { option: 'sana-barreja', label: 'Sana Barreja' },
  { option: 'sana-safinaz', label: 'Sana Safinaz' },
  { option: 'sangeeta-boochra', label: 'Sangeeta Boochra' },
  { option: 'sangeeta-kilachand', label: 'Sangeeta Kilachand' },
  { option: 'sania-maskatiya', label: 'Sania Maskatiya' },
  { option: 'satya-paul', label: 'Satya Paul' },
  { option: 'saundh', label: 'Saundh' },
  { option: 'sawan-gandhi', label: 'Sawan Gandhi' },
  { option: 'scarlet-sage', label: 'Scarlet Sage' },
  { option: 'seema-gujral', label: 'Seema Gujral' },
  { option: 'seema-thukral', label: 'Seema Thukral' },
  { option: 'sef', label: 'Sef' },
  { option: 'sehrish-rehan', label: 'Sehrish Rehan' },
  { option: 'shahin-mannan', label: 'Shahin Mannan' },
  { option: 'shalu-gambhir', label: 'Shalu Gambhir' },
  { option: 'shantanu-goenka', label: 'Shantanu Goenka' },
  { option: 'shantanu-nikhil', label: 'Shantanu & Nikhil' },
  { option: 'sharnita-nandwana', label: 'Sharnita Nandwana' },
  { option: 'sheetal-batra', label: 'Sheetal Batra' },
  { option: 'shehla-chatoor', label: 'Shehla Chatoor' },
  { option: 'shehla-khan', label: 'Shehla Khan' },
  { option: 'shift', label: 'Shift' },
  { option: 'shilpa-reddy', label: 'Shilpa Reddy' },
  { option: 'shireen-shahana', label: 'Shireen Shahana' },
  { option: 'shivan-narresh', label: 'Shivan & Narresh' },
  { option: 'shloka-khialani', label: 'Shloka Khialani' },
  { option: 'shriya-som', label: 'Shriya Som' },
  { option: 'shruti-sancheti', label: 'Shruti Sancheti' },
  { option: 'shweta-kapur', label: 'Shweta Kapur' },
  { option: 'shyamal-bhumika', label: 'Shyamal & Bhumika' },
  { option: 'shyam-narayan-prasad', label: 'Shyam Narayan Prasad' },
  { option: 'siddartha-tytler', label: 'Siddartha Tytler' },
  { option: 'siddhartha-bansal', label: 'Siddhartha Bansal' },
  { option: 'silhouette', label: 'Silhouette' },
  { option: 'silky-bindra', label: 'Silky Bindra' },
  { option: 'sil-sila', label: 'Sil Sila' },
  { option: 'simar-dugal', label: 'Simar Dugal' },
  { option: 'sneha-arora', label: 'Sneha Arora' },
  { option: 'sonaakshi-raaj', label: 'Sonaakshi Raaj' },
  { option: 'sonali-gupta', label: 'Sonali Gupta' },
  { option: 'sonam-luthria', label: 'Sonam Luthria' },
  { option: 'soup-by-sougat-paul', label: 'Soup By Sougat Paul' },
  { option: 'stoique', label: 'Stoique' },
  { option: 'studio-a', label: 'Studio A' },
  { option: 'studio-iris', label: 'Studio Iris' },
  { option: 'studio-ralana', label: 'Studio Ralana' },
  { option: 'studio-rigu', label: 'Studio Rigu' },
  { option: 'sue-mue', label: 'Sue Mue' },
  { option: 'suffuse', label: 'Suffuse' },
  { option: 'suffuse-by-sana-nair', label: 'Suffuse By Sana Nair' },
  { option: 'suhani-pittie', label: 'Suhani Pittie' },
  { option: 'suhino', label: 'Suhino' },
  { option: 'suket-dhir', label: 'Suket Dhir' },
  { option: 'sukriti-aakriti', label: 'Sukriti Aakriti' },
  { option: 'sulakshana-monga', label: 'Sulakshana Monga' },
  { option: 'suneet-varma', label: 'Suneet Varma' },
  { option: 'surbhi-gupta', label: 'Surbhi Gupta' },
  { option: 'surbhi-shah', label: 'Surbhi Shah' },
  { option: 'sureena-chowdhri', label: 'Sureena Chowdhri' },
  { option: 'surekha-jain', label: 'Surekha Jain' },
  { option: 'surendri-by-yogesh-chaudhary', label: 'Surendri By Yogesh Chaudhary' },
  { option: 'sva-sonam-and-paras-modi', label: 'SVA / Sonam And Paras Modi' },
  { option: 'swati-vijaivargie', label: 'Swati Vijaivargie' },
  { option: 'tahweave', label: 'Tahweave' },
  { option: 'tamanna-punjabi-kapoor', label: 'Tamanna Punjabi Kapoor' },
  { option: 'tarana', label: 'Tarana' },
  { option: 'tarrz-royal-ensemble', label: 'Tarrz Royal Ensemble' },
  { option: 'tarun-tahiliani', label: 'Tarun Tahiliani' },
  { option: 'tasuvre', label: 'Tasuvre' },
  { option: 'threads-motifs', label: 'Threads & Motifs' },
  { option: 'tilla', label: 'Tilla' },
  { option: 'tisa-studio', label: 'Tisa Studio' },
  { option: 'tokree', label: 'Tokree' },
  { option: 'torani', label: 'Torani' },
  { option: 'tul-palav', label: 'Tul Palav' },
  { option: 'ujala-azad', label: 'Ujala Azad' },
  { option: 'umar-sayeed', label: 'Umar Sayeed' },
  { option: 'urvashi-kaur', label: 'Urvashi Kaur' },
  { option: 'vaayu', label: 'Vaayu' },
  { option: 'vaishali-s', label: 'Vaishali S' },
  { option: 'vanshik', label: 'Vanshik' },
  { option: 'varsha-ritu', label: 'Varsha & Ritu' },
  { option: 'varun-bahl', label: 'Varun Bahl' },
  { option: 'varun-nidhika', label: 'Varun Nidhika' },
  { option: 'vibrance-by-anaya', label: 'Vibrance By Anaya' },
  { option: 'vikram-phadnis', label: 'Vikram Phadnis' },
  { option: 'vivek-narang', label: 'Vivek Narang' },
  { option: 'vvani-by-vani-vats', label: 'Vvani By Vani Vats' },
  { option: 'waraq', label: 'Waraq' },
  { option: 'warp-n-weft', label: 'Warp N Weft' },
  { option: 'weaver-story', label: 'Weaver Story' },
  { option: 'whim', label: 'Whim' },
  { option: 'yam', label: 'Yam' },
  { option: 'young-earthlings', label: 'Young Earthlings' },
  { option: 'zaha', label: 'Zaha' },
  { option: 'zainab-chottani', label: 'Zainab Chottani' },
  { option: 'zainab-salman', label: 'Zainab Salman' },
  { option: 'zara-shahjahan', label: 'Zara Shahjahan' },
  // Dhobara: there is deliberately NO 'Other' option. Every listing must be
  // tied to a designer label Dhobara has accepted — a seller whose designer
  // isn't on this list is asked to contact us so we can review adding them,
  // rather than self-declaring a label. See the note rendered under the
  // Designer field in EditListingDetailsForm.js.
  //
  // This list is kept in step with ALL_DESIGNERS in src/data/designers.js (the
  // "Designers We Accept" page): every designer advertised there must be
  // pickable here, or sellers hit a dead end. Option keys are slugify(label)
  // from that same file, so /designer/<slug> lines up — except for five
  // historical keys that predate the convention and are bridged by
  // DESIGNER_SLUG_ALIASES rather than renamed, since listings already store them.
];

export const listingFields = [
  // ── Designer ───────────────────────────────────────────────────────────────
  {
    key: 'designer',
    scope: 'public',
    schemaType: 'enum',
    enumOptions: DESIGNER_OPTIONS,
    filterConfig: {
      indexForSearch: true,
      filterType: 'SelectSingleFilter',
      label: 'Designer',
      group: 'primary',
    },
    showConfig: {
      label: 'Designer',
      isDetail: true,
    },
    saveConfig: {
      label: 'Designer',
      placeholderMessage: 'Select a designer',
      isRequired: true,
      requiredMessage: 'Please select a designer.',
    },
  },

  // ── Collection ─────────────────────────────────────────────────────────────
  {
    key: 'collection',
    scope: 'public',
    schemaType: 'enum',
    enumOptions: [
      { option: 'bridal', label: 'Bridal' },
      { option: 'formals', label: 'Formals' },
      { option: 'casual', label: 'Casual' },
      { option: 'mens', label: 'Mens' },
      { option: 'kids', label: 'Kids' },
    ],
    filterConfig: {
      indexForSearch: true,
      filterType: 'SelectSingleFilter',
      label: 'Collection',
      group: 'primary',
    },
    showConfig: {
      label: 'Collection',
      isDetail: true,
    },
    saveConfig: {
      label: 'Collection',
      placeholderMessage: 'Select a collection',
      isRequired: true,
      requiredMessage: 'Please select a collection.',
    },
  },

  // ── What is included (garment pieces) ──────────────────────────────────────
  {
    key: 'garmentType',
    scope: 'public',
    schemaType: 'multi-enum',
    enumOptions: [
      { option: 'kameez', label: 'Kameez' },
      { option: 'kurta', label: 'Kurta' },
      { option: 'sherwani', label: 'Sherwani' },
      { option: 'nehru-jacket', label: 'Nehru Jacket' },
      { option: 'waistcoat', label: 'Waistcoat' },
      { option: 'shalwaar', label: 'Shalwaar' },
      { option: 'kaftan', label: 'Kaftan' },
      { option: 'lehenga', label: 'Lehenga' },
      { option: 'cholee', label: 'Cholee' },
      { option: 'dupatta', label: 'Dupatta' },
      { option: 'under-shirt', label: 'Under-shirt' },
      { option: 'shawl', label: 'Shawl' },
      { option: 'turban', label: 'Turban' },
      { option: 'pajama', label: 'Pajama' },
    ],
    filterConfig: {
      indexForSearch: true,
      filterType: 'SelectMultipleFilter',
      label: 'What is included',
      searchMode: 'has_any',
      group: 'primary',
    },
    showConfig: {
      label: 'What is included',
    },
    saveConfig: {
      label: 'What is included?',
      isRequired: true,
      requiredMessage: 'Please select at least one garment piece.',
    },
  },

  // ── Condition ──────────────────────────────────────────────────────────────
  {
    key: 'condition',
    scope: 'public',
    schemaType: 'enum',
    enumOptions: [
      { option: 'new-with-tags', label: 'New with Tags' },
      { option: 'like-new', label: 'Like New' },
      { option: 'excellent', label: 'Excellent' },
      { option: 'good', label: 'Good' },
      { option: 'fair', label: 'Fair' },
    ],
    filterConfig: {
      indexForSearch: true,
      filterType: 'SelectSingleFilter',
      label: 'Condition',
      group: 'primary',
    },
    showConfig: {
      label: 'Condition',
      isDetail: true,
    },
    saveConfig: {
      label: 'Condition',
      placeholderMessage: 'Select condition',
      isRequired: true,
      requiredMessage: 'Please select the condition.',
    },
  },

  // ── Size ───────────────────────────────────────────────────────────────────
  {
    key: 'size',
    scope: 'public',
    schemaType: 'enum',
    enumOptions: [
      { option: 'xs', label: 'XS' },
      { option: 's', label: 'S' },
      { option: 'm', label: 'M' },
      { option: 'l', label: 'L' },
      { option: 'xl', label: 'XL' },
      { option: 'made-to-measure', label: 'Made-to-Measure' },
    ],
    filterConfig: {
      indexForSearch: true,
      filterType: 'SelectMultipleFilter',
      label: 'Size',
      group: 'primary',
    },
    showConfig: {
      label: 'Size',
      isDetail: true,
    },
    saveConfig: {
      label: 'Size',
      placeholderMessage: 'Select a size',
      isRequired: true,
      requiredMessage: 'Please select a size.',
    },
  },

  // ── Fabric ─────────────────────────────────────────────────────────────────
  {
    key: 'fabric',
    scope: 'public',
    schemaType: 'enum',
    enumOptions: [
      { option: 'lawn', label: 'Lawn' },
      { option: 'cotton', label: 'Cotton' },
      { option: 'linen', label: 'Linen' },
      { option: 'chiffon', label: 'Chiffon' },
      { option: 'georgette', label: 'Georgette' },
      { option: 'silk-pure-silk', label: 'Silk / Pure Silk' },
      { option: 'raw-silk', label: 'Raw Silk' },
      { option: 'crepe', label: 'Crepe' },
      { option: 'organza', label: 'Organza' },
      { option: 'net-tulle', label: 'Net / Tulle' },
      { option: 'velvet', label: 'Velvet' },
      { option: 'karandi', label: 'Karandi' },
      { option: 'khaddar', label: 'Khaddar' },
      { option: 'wool-blend', label: 'Wool / Wool Blend' },
      { option: 'tissue-silk', label: 'Tissue / Tissue Silk' },
      { option: 'banarasi', label: 'Banarasi' },
      { option: 'jamawar', label: 'Jamawar' },
      { option: 'chanderi', label: 'Chanderi' },
      { option: 'satin', label: 'Satin' },
      { option: 'brocade', label: 'Brocade' },
      { option: 'blend-mixed', label: 'Blend / Mixed Fabric' },
    ],
    showConfig: {
      label: 'Fabric',
      isDetail: true,
    },
    saveConfig: {
      label: 'Fabric',
      placeholderMessage: 'Select a fabric',
      isRequired: false,
    },
  },

  // ── Color ──────────────────────────────────────────────────────────────────
  {
    key: 'color',
    scope: 'public',
    schemaType: 'enum',
    enumOptions: [
      { option: 'white-ivory', label: 'White / Off-White / Ivory' },
      { option: 'cream-beige-nude', label: 'Cream / Beige / Nude' },
      { option: 'blush-baby-pink', label: 'Blush / Baby Pink' },
      { option: 'pink-fuchsia', label: 'Pink / Hot Pink / Fuchsia' },
      { option: 'peach-coral', label: 'Peach / Coral' },
      { option: 'red-crimson', label: 'Red / Crimson' },
      { option: 'maroon-burgundy-wine', label: 'Maroon / Burgundy / Wine' },
      { option: 'orange-rust-terracotta', label: 'Orange / Rust / Terracotta' },
      { option: 'yellow-mustard-gold', label: 'Yellow / Mustard / Gold' },
      { option: 'lime-chartreuse', label: 'Lime / Chartreuse' },
      { option: 'mint-sage-olive', label: 'Mint / Sage / Olive' },
      { option: 'green-emerald', label: 'Green / Emerald / Bottle Green' },
      { option: 'teal-turquoise', label: 'Teal / Turquoise' },
      { option: 'sky-blue-baby-blue', label: 'Sky Blue / Baby Blue' },
      { option: 'blue-royal-cobalt', label: 'Blue / Royal Blue / Cobalt' },
      { option: 'blue', label: 'Blue' },
      { option: 'navy-midnight', label: 'Navy / Midnight Blue' },
      { option: 'lavender-lilac', label: 'Lavender / Lilac' },
      { option: 'purple-plum-mauve', label: 'Purple / Plum / Mauve' },
      { option: 'grey-charcoal', label: 'Grey / Charcoal / Ash' },
      { option: 'black', label: 'Black' },
      { option: 'brown-chocolate-tan', label: 'Brown / Chocolate / Tan' },
      { option: 'multi-color-printed', label: 'Multi-color / Printed' },
    ],
    showConfig: {
      label: 'Color',
      isDetail: true,
    },
    saveConfig: {
      label: 'Color',
      placeholderMessage: 'Select a color',
      isRequired: false,
    },
  },

  // ── Measurements (free text) ───────────────────────────────────────────────
  {
    key: 'measurements',
    scope: 'public',
    schemaType: 'text',
    showConfig: {
      label: 'Measurements',
    },
    saveConfig: {
      label: 'Made-to-Measure measurements (if applicable)',
      placeholderMessage: 'e.g. Bust 36in, Waist 28in, Length 42in',
      isRequired: false,
    },
  },

  // ── Package size (shipping) ─────────────────────────────────────────────────
  // Dhobara: drives the UPS label's weight/dimensions in
  // server/api/shipstation-create-label.js (PACKAGE_SIZE_PRESETS) so heavier
  // items like sherwanis/bridal lehengas don't get rated as a 1lb poly
  // mailer. Not shown on the PDP (no showConfig) - it's a shipping detail,
  // not a buyer-facing attribute, and not searchable (no filterConfig).
  {
    key: 'packageSize',
    scope: 'public',
    schemaType: 'enum',
    // Derived so the seller picking a size and the buyer reading the Shipping
    // page see the same words for the same thing.
    enumOptions: SHIPPING_TIERS.tiers.map(t => ({
      option: t.size,
      label: `${t.label} (e.g. ${t.examples})`,
    })),
    saveConfig: {
      label: 'Package size (for shipping)',
      placeholderMessage: 'Select an approximate package size',
      isRequired: true,
      requiredMessage: 'Please select an approximate package size so we can quote accurate shipping.',
    },
  },

  // ── Proof of authenticity ──────────────────────────────────────────────────
  {
    key: 'authenticity',
    scope: 'public',
    schemaType: 'boolean',
    showConfig: {
      label: 'Proof of authenticity',
      isDetail: true,
    },
    saveConfig: {
      label: 'Do you have proof of authenticity? (e.g. official tags, receipts)',
      isRequired: false,
    },
  },
];

/**
 * Dhobara — SINGLE SOURCE OF TRUTH accessors for listing enum options.
 *
 * `listingFields` above defines every option a seller can pick. Anything that
 * needs the same options for a filter, a chip, or a card label must read them
 * through these helpers rather than keeping its own copy — DhobaraSearchPage
 * used to hold verbatim duplicates of seven of these lists, and they drifted:
 * a designer ended up with the wrong label (so the filter chip said one name
 * and queried another), a second designer was missing entirely, and the 'blue'
 * colour added in July never made it across.
 *
 * Note this is deliberately NOT the same thing as src/config/dhobaraFilters.js,
 * which is a curated *subset* with shorter shopper-facing labels for the browse
 * pages. That file is allowed to differ — but every `value` in it must still be
 * a real option key from here, or its filter matches nothing.
 *
 * @param {string} key a listingFields key, e.g. 'designer', 'color', 'size'
 * @returns {Array<{option: string, label: string}>} [] if the key has no enum
 */
export const getListingEnumOptions = key =>
  listingFields.find(field => field.key === key)?.enumOptions || [];

/**
 * The same options as an option-key → label lookup, for rendering the label of
 * a value already stored on a listing.
 *
 * @param {string} key a listingFields key
 * @returns {Object<string, string>}
 */
export const getListingLabelMap = key =>
  Object.fromEntries(getListingEnumOptions(key).map(o => [o.option, o.label]));

/**
 * Readable fallback for an enum value with no option entry.
 *
 * Live listings can carry values this config doesn't know about — 'other',
 * or a designer slug from before the list was pruned. Without this they
 * surface raw in generated titles ("other — Lehenga", "nadia-farooqi — ...").
 * Turn the slug back into words so the worst case is merely imprecise
 * rather than obviously broken.
 */
export const humanizeEnumKey = key =>
  String(key || '')
    .split('-')
    .filter(Boolean)
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');

/** Label for an enum value, falling back to a humanized form of the key. */
export const labelForEnum = (labelMap, key) =>
  labelMap[key] || humanizeEnumKey(key);

///////////////////////////////////////////////////////////////////////
// Listing type — garment selling via default-purchase process       //
///////////////////////////////////////////////////////////////////////

export const listingTypes = [
  {
    listingType: 'garment-selling',
    label: 'Sell a garment',
    transactionType: {
      process: 'default-purchase',
      alias: 'default-purchase/release-1',
      unitType: 'item',
    },
    stockType: 'oneItem',
    defaultListingFields: {
      shipping: true,
      pickup: false,
      // Dhobara (June 24, 2026): temporarily allow publishing without Stripe
      // payout details connected, so sellers aren't blocked on Stripe
      // verification before they can list. This is a supported Sharetribe
      // escape hatch (see the comment next to requirePayoutDetails() in
      // EditListingWizard.js) - listings publish normally, but buyers can't
      // complete checkout/payment on them until the seller connects Stripe.
      // Flip back to `true` once sellers are expected to have Stripe set up
      // before listing (e.g. once early testing is done).
      payoutDetails: false,
      // Dhobara hides the description field from the Details step entirely, so it is
      // never submitted. displayDescription() defaults to true unless this is set to
      // false, which made tabCompleted(DETAILS) always evaluate to false (since
      // hasValidDescription read an undefined `description`) — silently bouncing the
      // wizard back to Step 2 every time "Next"/"Continue" was clicked on Step 2.
      description: false,
    },
  },
];

export const enforceValidListingType = false;
